import React from 'react';
import {classes, style} from './doppe-action-back-header-new.st.css';
import {Button, Icon} from '@wix/devzai-utils-react';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {
    DoppeActionTypeSpeedDialWidgetIconArrowLeft,
    DoppeActionTypeSpeedDialWidgetIconArrowRight
} from '../../doppe-action-type-speed-dial/doppe-action-type-speed-dial-widget/doppe-action-type-speed-dial-widget-icons';
import {uiPartsGroupCreateMarking} from '@wix/devzai-utils-common';
import {DoppePageViewerPartsGroups} from '../../../components/doppe-page-viewer-part/doppe-page-viewer-part';
import {
    useDoppViewerIsRtl
} from '../../../components/doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react';

export const DoppeActionBackHeaderNew = React.memo(function DoppeActionBackHeaderNew(
    props: {
        onBackClick: () => void;
        title?: string;
        subtitle?: string;
        hasBorderBottom: boolean;
    }
) {
    const {
        onBackClick,
        title,
        subtitle,
        hasBorderBottom
    } = props;

    const isRtl = useDoppViewerIsRtl();

    return (
        <div
            className={style(classes.root, {hasBorderBottom: hasBorderBottom}, FlexLayout.row.alignToCenter)}
        >
            <Button
                className={style(classes.backIcon, {})}
                onClick={() => {
                    onBackClick();
                }}
                {...uiPartsGroupCreateMarking(DoppePageViewerPartsGroups.BackButton)}
            >
                <Icon
                    icon={isRtl ? DoppeActionTypeSpeedDialWidgetIconArrowRight : DoppeActionTypeSpeedDialWidgetIconArrowLeft}
                />
            </Button>
            {
                title || subtitle ?
                    <div
                        className={style(classes.titleHeader, FlexLayout.column.default, FlexLayout.fillRemainingHorizontalSpace)}
                    >
                        {
                            title ?
                                <div className={style(classes.title, {}, CommonClasses.ellipsis)}>{title}</div>
                                :
                                null
                        }
                        {
                            subtitle ?
                                <div className={style(classes.subtitle, {}, CommonClasses.lineClamp(2))}>{subtitle}</div>
                                :
                                null
                        }
                    </div>
                    :
                    null
            }
        </div>
    );
});


